<div class="dvf-list">
    <% if (numberOfTransactions > 0) { %>
        <div class="dvf-list__title">
            Découvrez les biens vendus
        </div>
        <div class="dvf-list__subtitle">
            <img src="/static/images/estima-pro.svg" class="dvf-list__illustration" alt="">
            <div class="margin-left-triple">Trouvez <strong>les prix de vente</strong> des biens <strong>fournis par Etalab</strong>.</div>
        </div>
        <div class="dvf-list__subtitle">
            <img src="/static/images/listing.svg" class="dvf-list__illustration" alt="">
            <div class="margin-left-triple">Découvrez <strong>le prix actualisé</strong> des biens <strong>estimé par MeilleursAgents</strong>.</div>
        </div>
        <div class="dvf-list__count" data-dvf-list-count>
            <%=
                numberOfTransactions > 1  ?
                    numberOfTransactions + ' biens vendus trouvés' :
                    numberOfTransactions + ' bien vendu trouvé'
            %> près de cette adresse
        </div>
        <%= firstThreeTransactions.length > 0 && firstThreeTransactions %>
        <a
            href="/prix-ventes-realisees/form/"
            class="panel dvf-transaction dvf-transaction--list btn-reset flex flex-center flex-column margin-top margin-bottom no-underline"
            data-ua-hit-type="event"
            data-ua-event-category="DVF"
            data-ua-event-action="go:past_sales_report"
            data-ua-event-label="dvf_explorer:past_sales_report:list_bloc"
        >
            <img src="/static/images/past-sale.svg" style="width: auto;" alt="Obtenez les prix des biens déjà vendus">
            <h3 class="no-margin-top margin-bottom-double text--center">Consulter le prix de vente et toutes les photos des biens vendus</h3>
            <p class="btn btn--primary no-margin">Obtenir les photos et les prix</p>
        </a>
        <%= fourthAndFollowingTransactions.length > 0 && fourthAndFollowingTransactions %>
    <% } else { %>
        <div class="dvf-list__title">Aucun bien vendu trouvé</div>
        <div class="padding-double text--center">
            <img src="/static/images/dvf-no-result.svg">
        </div>
        <div class="dvf-list__subtitle">
            Élargissez vos critères de recherche ou déplacez-vous sur la carte pour afficher d'autres biens vendus.
        </div>
    <% } %>
</div>
